export default __webpack_public_path__ + "static/media/Praetoric Arbitrator.65fd3037.jpg";